module.exports = __webpack_public_path__ + "static/media/pricing@2x.afe09bb7.webm";